// ---------------------------------------------------------------------------
// Lightweight structured logger used by the sync/data modules.
//
// Why not just `console.*`? Two reasons:
//   1. Call sites emit structured payloads (event + fields) instead of
//      hand-formatted strings, so we can add richer routing later (send to
//      Sentry, forward to a backend, etc.) without touching every caller.
//   2. Makes sync-fallback frequency correlatable: every fallback emits a
//      known event name with predictable fields.
//
// Errors are additionally piped through `reportError()` from
// `src/handlers/errorReporter` so any future Sentry/Posthog hook picks them
// up alongside uncaught window / promise rejections.
// ---------------------------------------------------------------------------

import { reportError } from "src/handlers/errorReporter";

function emit(level, event, fields) {
  const method = level === "error" ? "error" : level === "warn" ? "warn" : "info";
  const consoleFn = console[method] || console.warn;
  // Keep the human-readable prefix, but pass the structured fields as a
  // second arg so browser devtools collapse it nicely.
  consoleFn(`[netbase] ${event}`, fields || {});
  if (level === "error") {
    try {
      reportError(event, fields);
    } catch {
      // Never let reporter plumbing break the caller.
    }
  }
}

export const log = {
  info: (event, fields) => emit("info", event, fields),
  warn: (event, fields) => emit("warn", event, fields),
  error: (event, fields) => emit("error", event, fields)
};
